import { motion } from "framer-motion";

const LIFESTYLE =
  "https://images.unsplash.com/photo-1763913086998-ef72958e93ab?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NjZ8MHwxfHNlYXJjaHwxfHxzdHJlZXR3ZWFyJTIwbW9kZWwlMjBvdXRkb29yJTIwbW91bnRhaW58ZW58MHx8fHwxNzg2MjIwMDY3fDA&ixlib=rb-4.1.0&q=85";

const Lifestyle = () => {
  return (
    <section className="relative h-[70vh] md:h-screen overflow-hidden border-b border-[var(--line)]">
      <motion.img
        src={LIFESTYLE}
        alt="Streetwear model outdoors"
        initial={{ scale: 1.15 }}
        whileInView={{ scale: 1 }}
        viewport={{ once: true }}
        transition={{ duration: 1.6, ease: [0.22, 1, 0.36, 1] }}
        className="absolute inset-0 w-full h-full object-cover"
      />
      <div className="absolute inset-0 bg-gradient-to-t from-black via-transparent to-black/30" />
      <div className="relative z-10 h-full flex items-end">
        <div className="mx-auto max-w-[1600px] w-full px-6 md:px-12 pb-16 md:pb-24">
          <motion.h2
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
            className="font-anton uppercase text-5xl md:text-8xl tracking-tighter leading-[0.85] max-w-4xl"
          >
            Wear it where <br />
            <span className="text-[var(--accent)]">the road ends.</span>
          </motion.h2>
        </div>
      </div>
    </section>
  );
};

export default Lifestyle;
